<template>
  <main class="">
    <LoadingScreenComponent v-if="signupInProgress" />

    <section class="user-section">
      <div class="user-data-box">
        <h1 class="heading-primary">Regístrate</h1>

        <div class="google-button-container" id="googleSignupButton"></div>

        <div class="or-div">
          <span>o</span>
        </div>

        <form class="user-form" @submit="submit" autocomplete="on">
          <InputComponent
            label="Email"
            inputType="email"
            autocomplete="email"
            :model-value="email"
            :error="errors.email"
            @change="handleChange"
          />

          <InputComponent
            label="Contraseña"
            inputType="password"
            v-model="password"
            autocomplete="password"
            :error="errors.password"
          />

          <div class="user-form-actions">
            <button class="btn btn--full" type="submit">Regístrate</button>
            <button
              class="btn btn--register"
              type="button"
              @click="navigateLogin"
            >
              <span>Iniciar Sesión</span>
              <img
                src="../../assets/img/icons/register.svg"
                alt="register icon"
                draggable="false"
              />
            </button>
          </div>
        </form>
      </div>
      <ToastComponent ref="toast" />
    </section>
  </main>
</template>

<script>
import InputComponent from "@/components/shared/InputComponent.vue";
import { getCurrentInstance } from "vue";
import router from "@/router";
import { ToastTypes } from "@/features/toastTypes";
import LoadingScreenComponent from "@/components/shared/LoadingScreenComponent.vue";
import ToastComponent from "@/components/shared/ToastComponent.vue";

import { object, string } from "yup";
import { useField, useForm } from "vee-validate";

export default {
  data() {
    return {
      signupInProgress: false,
    };
  },
  setup() {
    const validationSchema = object({
      email: string()
        .email("Ingrese un email válido")
        .required("Debe ingresar un email"),
      password: string().required("Debe ingresar una contraseña"),
    });

    const { handleSubmit, errors } = useForm({
      validationSchema,
    });

    const { value: email, handleChange } = useField("email");
    const { value: password } = useField("password");

    const instance = getCurrentInstance();

    const submit = handleSubmit((values) => {
      instance.ctx.signup(values);
    });

    return {
      email,
      password,
      submit,
      errors,
      handleChange,
    };
  },
  components: { ToastComponent, LoadingScreenComponent, InputComponent },
  mounted() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    this.showGoogleButton();
  },
  methods: {
    async signup(credentials) {
      this.signupInProgress = true;
      this.scrollToTop();
      try {
        await this.$store.dispatch("auth/signup", credentials);
        if (this.cartLength > 0) {
          await router.push("/payment");
        } else {
          await router.push("/");
        }
      } catch (err) {
        this.$refs.toast.fire(ToastTypes.Error, err.response.data.message);
      }
      this.signupInProgress = false;
    },
    showGoogleButton() {
      const google = window.google;

      google.accounts.id.initialize({
        client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
        callback: this.authWithGoogle,
        context: "signup",
      });

      google.accounts.id.renderButton(
        document.getElementById("googleSignupButton"),
        {
          theme: "filled_black",
          size: "large",
          shape: "pill",
          locale: "es",
          text: "signup_with",
        } // button attributes
      );

      // display the One Tap dialog
      google.accounts.id.prompt();
    },
    async authWithGoogle(googleResponse) {
      this.signupInProgress = true;
      this.scrollToTop();
      try {
        await this.$store.dispatch(
          "auth/authWithGoogle",
          googleResponse.credential
        );
        if (this.cartLength > 0) {
          await router.push("/payment");
        } else {
          await router.push("/");
        }
      } catch (err) {
        this.$refs.toast.fire(ToastTypes.Error, err.response.data.message);
      }
      this.signupInProgress = false;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    navigateLogin() {
      this.email = "";
      this.password = "";

      router.push("/login");
    },
  },
  computed: {
    cartLength() {
      return this.$store.state.order.newOrder.items.length;
    },
  },
};
</script>

<style scoped>
.btn--register {
  display: flex;
  align-items: center;
  padding: 0 1.5rem;
  color: #495057;
  gap: 2px;
}

.google-button-container {
  margin-top: 4rem;
  display: flex;
  justify-content: center;
  width: 100%;
}

.or-div {
  width: 100%;
  display: flex;
  flex-direction: row;
  text-transform: uppercase;
  border: none;
  font-size: 1.2rem;
  font-weight: 500;
  margin-top: 4rem;
}

.or-div:before,
.or-div:after {
  content: "";
  border-bottom: 1px solid #cfcfcf;
  flex: 1 0 auto;
  height: 0.5em;
  margin: 0;
}

.or-div span {
  text-align: center;
  flex: 0.2 0 auto;
  margin: 0;
}
</style>
